module.exports = __webpack_public_path__ + "static/media/lecture.f731720f.svg";